/*
 * @Author: Teemo Ding
 * @Date: 2021-08-18 13:42:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-17 14:04:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/RecipientAddressBook/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Collapse } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const RecipientAddressBook = ({ addressBooks }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.recipientAddressBook} ${css.wrapperContainer}`}
        title={getI18n(
          'customerDatabaseSetting.recipientAddressBook.recipientAddressBook',
        )}>
        <div>
          <Collapse accordion>
            {(addressBooks || []).map((item, index) => (
              <Collapse.Panel
                className={css.customAddress}
                header={`${getI18n(
                  'customerList.recipientAddressBook.address',
                )} ${index + 1} ${
                  item.crossBorder
                    ? '(' +
                      _.get(item, 'deliveryAddress.countryRegion', '') +
                      ' Cross-border)'
                    : ''
                }`}
                key={index}>
                <div className={css.informationContainer}>
                  <div className={css.items}>
                    <div className={css.itemsTitle}>
                      {getI18n(
                        'customerDatabaseSetting.recipientAddressBook.recipientInformation',
                      )}
                    </div>
                    {_.get(item, 'recipient.firstName', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.firstName',
                          )}
                        </span>
                        <span>{_.get(item, 'recipient.firstName', '')}</span>
                      </div>
                    )}
                    {_.get(item, 'recipient.lastName', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.lastName',
                          )}
                        </span>
                        <span>{_.get(item, 'recipient.lastName', '')}</span>
                      </div>
                    )}
                    {_.get(item, 'recipient.fullName', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.fullName',
                          )}
                        </span>
                        <span>{_.get(item, 'recipient.fullName', '')}</span>
                      </div>
                    )}
                    {_.get(item, 'recipient.mobile', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.mobileNumber',
                          )}
                        </span>
                        <span>
                          {_.get(item, 'recipient.areaCode', '') &&
                            '+' + _.get(item, 'recipient.areaCode', '')}{' '}
                          {_.get(item, 'recipient.mobile', '')}
                        </span>
                      </div>
                    )}
                    {_.get(item, 'recipient.email', '') && (
                      <div className={css.item}>
                        <span>{getI18n('general.email')}</span>
                        <span>{_.get(item, 'recipient.email', '')}</span>
                      </div>
                    )}
                  </div>
                  <div className={css.items}>
                    <div className={css.itemsTitle}>
                      {getI18n(
                        'customerDatabaseSetting.recipientAddressBook.deliveryInformation',
                      )}
                    </div>
                    {_.get(item, 'deliveryAddress.countryRegion', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.country / Region',
                          )}
                        </span>
                        <span>
                          {_.get(item, 'deliveryAddress.countryRegion', '')}
                        </span>
                      </div>
                    )}
                    {_.get(item, 'deliveryAddress.address1', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.addressLine1',
                          )}
                        </span>
                        <span>
                          {_.get(item, 'deliveryAddress.address1', '')}
                        </span>
                      </div>
                    )}
                    {_.get(item, 'deliveryAddress.address2', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n(
                            'customerList.recipientAddressBook.addressLine2',
                          )}
                        </span>
                        <span>
                          {_.get(item, 'deliveryAddress.address2', '')}
                        </span>
                      </div>
                    )}
                    {_.get(item, 'deliveryAddress.city', '') && (
                      <div className={css.item}>
                        <span>
                          {getI18n('customerList.recipientAddressBook.city')}
                        </span>
                        <span>{_.get(item, 'deliveryAddress.city', '')}</span>
                      </div>
                    )}
                  </div>
                </div>
              </Collapse.Panel>
            ))}
          </Collapse>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default RecipientAddressBook;
